import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useSettings } from "../lib/useSettings";

export default function Footer() {
  const s = useSettings();
  return (
    <footer className="border-t border-white/10 bg-slate-950">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <Logo />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed">
            Professional websites, AI voice agents, and intelligent customer communication
            automation for growing businesses.
          </p>
        </div>
        <div>
          <h4 className="font-mono2 text-xs tracking-[0.25em] text-blue-400 mb-4">COMPANY</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link className="hover:text-white transition-colors" to="/about">About Us</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/industries">Industries</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/pricing">Pricing</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/contact">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono2 text-xs tracking-[0.25em] text-blue-400 mb-4">SOLUTIONS</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link className="hover:text-white transition-colors" to="/services#website-development">Website Development</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/services#ai-voice-agent">AI Voice Agent</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/services#whatsapp-ai">WhatsApp AI Agent</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/services#website-chat">Website Chat Agent</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/services#social-ai">Instagram &amp; Facebook AI</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono2 text-xs tracking-[0.25em] text-blue-400 mb-4">REACH US</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            {s?.business_email && <li>{s.business_email}</li>}
            {s?.business_phone && <li>{s.business_phone}</li>}
            {s?.business_address && <li>{s.business_address}</li>}
            {s?.business_hours && <li>{s.business_hours}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>&copy; {new Date().getFullYear()} RIDGELINE DIGI PARTNER. All rights reserved.</span>
          <span className="flex gap-5">
            <Link className="hover:text-slate-300 transition-colors" to="/privacy">Privacy Policy</Link>
            <Link className="hover:text-slate-300 transition-colors" to="/terms">Terms of Service</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
